
import React, { useState } from 'react';
import useMounted from '../../hooks/useMounted';
import { post } from '../../helpers/api_helper';
import { utc_local, amountFormatUse, getLast6MonthsTimestamps, getLast30DaysWithTimestamps } from '../../helpers/Helper';
import { GET_DASHBOARD_DATA, GET_DASHBOARD_ATTENDANCE_DATA, GET_DASHBOARD_SALARY_DATA, GET_DASHBOARD_ATTENDANCE_CHART_DATA } from '../../helpers/url_helper';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import Loader from './../../components/Loader';
import AttendanceChart from '../../components/AttendanceChart';
import SalaryChart from './../../components/SalaryChart';
import AppInstallGuide from './../../components/AppInstallGuide';
import { Link } from 'react-router-dom';

const Dashboard = (props) => {
    const { t } = useTranslation();


    const [ShowLoader, SetShowLoader] = useState(false);
    const [totalEmployee, SetTotalEmployee] = useState(0);
    const [totalCredit, SetTotalCredit] = useState(0);
    const [active_plan_info, SetActive_plan_info] = useState(null);
    const [OrderList, SetOrderList] = useState([]);

    const [DateArray, SetDateArray] = useState([]);
    const [MonthArray, SetMonthArray] = useState([]);
    const [at_date, set_at_date] = useState(null);
    const [at_chart_date, set_at_chart_date] = useState(null);
    const [salary_date, set_salary_date] = useState(null);

    //Attendance data
    const [at_date_loading, set_at_date_loading] = useState(false);
    const [TotalEmployees, SetTotalEmployees] = useState(0);
    const [TotalPresent, SetTotalPresent] = useState(0);
    const [TotalAbsent, SetTotalAbsent] = useState(0);
    const [TotalOtHours, SetTotalOtHours] = useState(0);
    const [PresentRate, SetPresentRate] = useState(0);
    const [AbsentRate, SetAbsentRate] = useState(0);

    // salary_data
    const [salary_data_loading, set_salary_data_loading] = useState(false);
    const [TotalSalary, SetTotalSalary] = useState(0);
    const [TotalOtSalary, SetTotalOtSalary] = useState(0);
    const [TotalPayment, SetTotalPayment] = useState(0);
    const [SalaryChartData, SetSalaryChartData] = useState([]);

    //Attendance
    const [attendance_chat_loading, set_attendance_chat_loading] = useState(false);
    const [AttendanceChartData, SetAttendanceChartData] = useState([]);

    useMounted(() => {
        async function get_detaile() {

            // at_date
            const date_array = getLast30DaysWithTimestamps();
            SetDateArray(date_array)
            set_at_date(date_array[0]);
            get_attendance_data(date_array[0]);

            const month_array = getLast6MonthsTimestamps();
            SetMonthArray(month_array);

            //attendance chart
            set_at_chart_date(month_array[0]);
            get_attendance_chart_data(month_array[0]);

            // salary
            set_salary_date(month_array[0]);
            get_salary_data(month_array[0]);

            getHomeDate();
        }
        get_detaile();
    }, [])

    const getHomeDate = async () => {
        SetShowLoader(true);
        var res_data = await post(GET_DASHBOARD_DATA, {});
        if (res_data.status) {
            SetTotalEmployee(res_data.data.totalEmployeeAdd);
            SetTotalCredit(res_data.data.totalCredit);
            SetActive_plan_info(res_data.data.active_plan_info);
            SetOrderList(res_data.data.order_list);
        } else {
            toast.error(res_data.message);
        }
        SetShowLoader(false);
    }

    const [showPlanAlert, setShowPlanAlert] = useState(true);

    const get_attendance_data = async (date) => {
        set_at_date_loading(true);
        var res_data = await post(GET_DASHBOARD_ATTENDANCE_DATA, date);
        if (res_data.status) {
            SetTotalEmployees(res_data.data.total_employee);
            SetTotalPresent(res_data.data.totalPresent);
            SetTotalAbsent(res_data.data.totalAbsent);
            SetTotalOtHours(res_data.data.totalOTHours);
            SetPresentRate(res_data.data.presentRate);
            SetAbsentRate(res_data.data.absentRate);
        } else {
            toast.error(res_data.message);
        }
        set_at_date_loading(false);
    }

    const get_salary_data = async (date) => {
        set_salary_data_loading(true);
        var res_data = await post(GET_DASHBOARD_SALARY_DATA, date);
        if (res_data.status) {
            SetTotalSalary(res_data.data.totalSalary);
            SetTotalOtSalary(res_data.data.totalOTSalary);
            SetTotalPayment(res_data.data.totalPayment);
            SetSalaryChartData(res_data.data.cahtData);
        } else {
            toast.error(res_data.message);
        }
        set_salary_data_loading(false);
    }

    const get_attendance_chart_data = async (date) => {
        set_attendance_chat_loading(true);
        var res_data = await post(GET_DASHBOARD_ATTENDANCE_CHART_DATA, date);
        if (res_data.status) {
            SetAttendanceChartData(res_data.data.cahtData);
        } else {
            toast.error(res_data.message);
        }
        set_attendance_chat_loading(false);
    }

    return (
        <>
            {ShowLoader && <Loader />}
            {(active_plan_info && !active_plan_info.plan_status && showPlanAlert) &&
                <div className="alert alert-danger alert-dismissible fade show" role="alert">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-exclamation-triangle-fill flex-shrink-0 me-3" viewBox="0 0 16 16" role="img" aria-label="Warning:">
                        <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"></path>
                    </svg>
                    <span dangerouslySetInnerHTML={{ __html: t('homePage.subscriptionExpired') }}></span>
                    <button type="button" className="btn-close" onClick={() => { setShowPlanAlert(false) }} ></button>
                </div>
            }
            <div className='row'>
                <div className='col-sm-12 col-lg-9'>
                    <div className='row'>
                        <div class="col-md-12 col-lg-6 order-2 mb-6 mb-3">
                            <div class="card">
                                <div class="card-header d-flex align-items-center justify-content-between">
                                    <h5 class=" m-0 me-2">
                                        Attendance
                                        {at_date_loading && <i className="fa fa-spinner ms-2 fa-spin"></i>}
                                    </h5>
                                    <div class="btn-group border">
                                        <div data-bs-toggle="dropdown" aria-expanded="false">
                                            <button type="button" class="btn btn-label-primary btn-sm">{(at_date) ? at_date.date : ''} <span className='dropdown-toggle dropdown-toggle-split ps-3 pe-0'></span></button>
                                        </div>
                                        <ul class="dropdown-menu" style={{ "zIndex": "9999", "maxHeight": "250px", "overflow": "auto" }}>
                                            {DateArray && DateArray.map((date) => {
                                                return <li className='pointer pt-2 pb-2 ps-3 pe-3 bg-light' onClick={() => { set_at_date(date); get_attendance_data(date); }}>{date.date}</li>;
                                            })}
                                        </ul>
                                    </div>
                                </div>
                                <div class="card-body pt-0 pb-0">
                                    <div className='list-group-item d-flex justify-content-between align-items-center border-bottom-dashed'>
                                        <h6 className='mb-2 mt-2'><span class="badge badge-dot bg-primary me-1 dot"></span> Total Employees :</h6>
                                        <h6 className='mb-2 mt-2'>{TotalEmployees}</h6>
                                    </div>
                                    <div className='list-group-item d-flex justify-content-between align-items-center border-bottom-dashed'>
                                        <h6 className='mb-2 mt-2'><span class="badge badge-dot bg-success me-1 dot"></span> Total Present :</h6>
                                        <h6 className='mb-2 mt-2'>{TotalPresent}</h6>
                                    </div>
                                    <div className='list-group-item d-flex justify-content-between align-items-center border-bottom-dashed'>
                                        <h6 className='mb-2 mt-2'><span class="badge badge-dot bg-danger me-1 dot"></span> Total Absent :</h6>
                                        <h6 className='mb-2 mt-2'>{TotalAbsent}</h6>
                                    </div>
                                    <div className='list-group-item d-flex justify-content-between align-items-center'>
                                        <h6 className='mb-2 mt-2'><span class="badge badge-dot bg-warning me-1 dot"></span> Total OT Hours :</h6>
                                        <h6 className='mb-2 mt-2'>{TotalOtHours} h</h6>
                                    </div>
                                    <hr />
                                    <div className='row'>
                                        <div className='col-sm-12 mb-3'>
                                            <h5 class=" m-0 me-2">Present Rate</h5>
                                        </div>
                                        <div className='col-6 mb-3'>
                                            <div className='circle circle-success mb-3'>
                                                <b>{PresentRate}%</b>
                                            </div>
                                            <div>
                                                <p className='text-center'>Present Rate</p>
                                            </div>
                                        </div>
                                        <div className='col-6 mb-3'>
                                            <div className='circle circle-danger mb-3'>
                                                <b className='text-danger'>{AbsentRate}%</b>
                                            </div>
                                            <div>
                                                <p className='text-center'>Absent Rate</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-12 col-lg-6 order-2 mb-6 mb-3">
                            <div class="card">
                                <div class="card-header d-flex align-items-center justify-content-between">
                                    <h5 class=" m-0 me-2">
                                        Salary
                                        {salary_data_loading && <i className="fa fa-spinner ms-2 fa-spin"></i>}
                                    </h5>
                                    <div class="btn-group border">
                                        <div data-bs-toggle="dropdown" aria-expanded="false">
                                            <button type="button" class="btn btn-label-primary btn-sm">{(salary_date) ? salary_date.month : ''} <span className='dropdown-toggle dropdown-toggle-split ps-3 pe-0'></span></button>
                                        </div>
                                        <ul class="dropdown-menu" style={{ "zIndex": "9999" }}>
                                            {MonthArray && MonthArray.map((date) => {
                                                return <li className='pointer pt-2 pb-2 ps-3 pe-3 bg-light' onClick={() => { set_salary_date(date); get_salary_data(date); }}>{date.month}</li>;
                                            })}
                                        </ul>
                                    </div>
                                </div>
                                <div class="card-body pt-0 pb-0">
                                    <div className='row'>
                                        <div className='col-6 col-sm-4 mb-2'>
                                            <p className='mb-1 text-secondary'>Total Salary</p>
                                            <h5 className='mb-0'>{amountFormatUse(TotalSalary,0)}</h5>
                                        </div>
                                        <div className='col-6 col-sm-4 mb-2'>
                                            <p className='mb-1 text-secondary'>OT Salary</p>
                                            <h5 className='mb-0'>{amountFormatUse(TotalOtSalary,0)}</h5>
                                        </div>
                                        <div className='col-6 col-sm-4 mb-2'>
                                            <p className='mb-1 text-secondary'>Total Payment</p>
                                            <h5 className='mb-0'>{amountFormatUse(TotalPayment,0)}</h5>
                                        </div>
                                    </div>
                                    <hr />
                                    <div className='row'>
                                        <div className='coms-12 mb-2'>
                                            <SalaryChart SalaryChartData={SalaryChartData} />
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div class="col-md-12 col-lg-12 mb-3">
                            <div class="card">
                                <div class="card-header d-flex align-items-center justify-content-between">
                                    <h5 class=" m-0 me-2">
                                        Attendance
                                        {attendance_chat_loading && <i className="fa fa-spinner ms-2 fa-spin"></i>}
                                    </h5>
                                    <div class="btn-group border">
                                        <div data-bs-toggle="dropdown" aria-expanded="false">
                                            <button type="button" class="btn btn-label-primary btn-sm">{(at_chart_date) ? at_chart_date.month : ''} <span className='dropdown-toggle dropdown-toggle-split ps-3 pe-0'></span></button>
                                        </div>
                                        <ul class="dropdown-menu" style={{ "zIndex": "9999" }}>
                                            {MonthArray && MonthArray.map((date) => {
                                                return <li className='pointer pt-2 pb-2 ps-3 pe-3 bg-light' onClick={() => { set_at_chart_date(date); get_attendance_chart_data(date); }}>{date.month}</li>;
                                            })}
                                        </ul>
                                    </div>
                                </div>
                                <div class="card-body pt-0 pb-0">
                                    <div className='row'>
                                        <div className='coms-12'>
                                            <AttendanceChart AttendanceChartData={AttendanceChartData} />
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    {OrderList.length > 0 &&
                        <div className='row mb-3'>
                            <div className='col-sm-12'>
                                <div className="card card-border-shadow-primary h-100">
                                    <div className="card-body">
                                        <div>
                                            <h6>{t('homePage.transaction.title')}</h6>
                                        </div>
                                        <div className='table-responsive'>
                                            <table className='table tabl-sm table-striped'>
                                                <thead>
                                                    <tr>
                                                        <th className='text-nowrap text-capitalize'>{t('homePage.transaction.orderNo')}</th>
                                                        <th className='text-nowrap text-capitalize'>{t('homePage.transaction.date')}</th>
                                                        <th className='text-nowrap text-capitalize'>{t('homePage.transaction.planName')}</th>
                                                        <th className='text-nowrap text-capitalize'>{t('homePage.transaction.type')}</th>
                                                        <th className='text-nowrap text-capitalize'>{t('homePage.transaction.transactionId')}</th>
                                                        <th className='text-nowrap text-capitalize'>{t('homePage.transaction.amount')}</th>
                                                        <th className='text-nowrap text-capitalize'>{t('homePage.transaction.status')}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {OrderList.map((order) => {
                                                        return (
                                                            <tr key={order.orderId}>
                                                                <td className='text-nowrap'>{order.orderId}</td>
                                                                <td className='text-nowrap'>{utc_local(order.createdAt, 'DD/MM/YYYY')}</td>
                                                                <td className='text-nowrap'>{order.name}, Total Employees - {order.totalEmployees}</td>
                                                                <td className='text-nowrap'>{order.subscriptionType}</td>
                                                                <td className='text-nowrap'>{order.transactionId}</td>
                                                                <td className='text-nowrap'>{amountFormatUse(order.amount)}</td>
                                                                <td className='text-nowrap'>
                                                                    {order.orderStatus === 'Pending' && <span className='border-0 badge bg-info'>Pending</span>}
                                                                    {order.orderStatus === 'Completed' && <span className='border-0 badge bg-success'>Completed</span>}
                                                                    {order.orderStatus === 'Canceled' && <span className='border-0 badge bg-danger'>Canceled</span>}
                                                                </td>
                                                            </tr>
                                                        )
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div>
                <div className='col-sm-12 col-lg-3 align-self-start' style={{"zIndex" : 8}}>
                    {(active_plan_info && active_plan_info.plan_status) &&
                        <div class="card mb-3">
                            <div class="card-body p-3">
                                <div className='row mb-1'>
                                    <div className='col-8'>
                                        <h6 class="mb-2">Plan</h6>
                                    </div>
                                    <div className='col-4'>
                                        <h6 class="mb-2 text-right text-success">Active</h6>
                                    </div>
                                </div>
                                <div className='border border-light rounded ps-2 pe-2 pt-2 pb-2'>
                                    <div class="row align-items-center">
                                        <div class="col-auto">
                                            <div class="avatar-sm bg-white fs-lg text-primary">
                                                <i className="bx bx-shield" style={{ "fontSize": "30px" }}></i>
                                            </div>
                                        </div>
                                        <div class="col ms-n3">
                                            <div><strong>{active_plan_info.name} Team</strong></div>
                                            <div><small >{utc_local(active_plan_info.startDate, 'DD MMM')} To {utc_local(active_plan_info.endDate, 'DD MMM YYYY')}</small></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="mt-2 d-flex justify-content-between align-items-center">
                                    <small >Usage: {totalEmployee}/{totalCredit} seats</small>
                                    <Link to="/profile/my-subscription" class="small-text font-weight-bold"><small>Manage</small></Link>
                                </div>
                            </div>
                        </div>
                    }

                    <div class="card mb-3">
                        <div class="card-body p-3">
                            <div className='row mb-1'>
                                <div className='col-12'>
                                    <h6 class="mb-2">Quick Actions</h6>
                                </div>
                            </div>
                            <div className='border border-light rounded ps-2 pe-2 pt-2 pb-2 mb-2'>
                                <Link to="/employees/add" className='text-dark'>
                                    <div class="row align-items-center">
                                        <div class="col-auto">
                                            <div class="avatar-sm bg-white fs-lg ">
                                                <i className="bx bx-user-plus" style={{ "fontSize": "30px" }}></i>
                                            </div>
                                        </div>
                                        <div class="col ms-n3">
                                            <h6 className='mb-0'>Add Employee</h6>
                                            <div><small className='text-secondary'>Create a new staff profile</small></div>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                            <div className='border border-light rounded ps-2 pe-2 pt-2 pb-2 mb-2'>
                                <Link to="/payments/add" className='text-dark'>
                                    <div class="row align-items-center">
                                        <div class="col-auto">
                                            <div class="avatar-sm bg-white fs-lg ">
                                                <i className="bx bx-rupee" style={{ "fontSize": "30px" }}></i>
                                            </div>
                                        </div>
                                        <div class="col ms-n3">
                                            <h6 className='mb-0'>Process Payment</h6>
                                            <div><small className='text-secondary'>Run payroll for this month</small></div>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                            <div className='border border-light rounded ps-2 pe-2 pt-2 pb-2 mb-2'>
                                <Link to="/attendance/add" className='text-dark'>
                                    <div class="row align-items-center">
                                        <div class="col-auto">
                                            <div class="avatar-sm bg-white fs-lg ">
                                                <i className="bx bx-time-five" style={{ "fontSize": "30px" }}></i>
                                            </div>
                                        </div>
                                        <div class="col ms-n3">
                                            <h6 className='mb-0'>Mark Attendance</h6>
                                            <div><small className='text-secondary'>Update daily attendance</small></div>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                            <div className='border border-light rounded ps-2 pe-2 pt-2 pb-2 mb-2'>
                                <Link to="/profile/setting" className='text-dark'>
                                    <div class="row align-items-center">
                                        <div class="col-auto">
                                            <div class="avatar-sm bg-white fs-lg ">
                                                <i className="bx bx-cog" style={{ "fontSize": "30px" }}></i>
                                            </div>
                                        </div>
                                        <div class="col ms-n3">
                                            <h6 className='mb-0'>Setting</h6>
                                            <div><small className='text-secondary'>Week Off Setting</small></div>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        </div>
                    </div>

                    <div class="card mb-3">
                        <div class="card-body p-3">
                            <div className='row mb-1'>
                                <div className='col-12'>
                                    <h6 class="mb-2">Download App</h6>
                                </div>
                            </div>
                            <div className='border border-light rounded ps-2 pe-2 pt-2 pb-2 mb-2'>
                                <Link to="https://staffhisab.in/staff-hisab-setup-1.0.0.exe" target='_blank' className='text-dark'>
                                    <div class="row align-items-center">
                                        <div class="col-auto">
                                            <div class="avatar-sm bg-white fs-lg ">
                                                <i className="bx bx-laptop" style={{ "fontSize": "30px" }}></i>
                                            </div>
                                        </div>
                                        <div class="col ms-n3">
                                            <h6 className='mb-0'>Desktop</h6>
                                            <div><small className='text-secondary'>Windows</small></div>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                            <div className='border border-light rounded ps-2 pe-2 pt-2 pb-2'>
                                <div class="row align-items-center pointer" data-bs-toggle="modal" data-bs-target="#AppInstallGuide" >
                                    <div class="col-auto">
                                        <div class="avatar-sm bg-white fs-lg ">
                                            <i className="bx bx-mobile-alt" style={{ "fontSize": "30px" }}></i>
                                        </div>
                                    </div>
                                    <div class="col ms-n3">
                                        <h6 className='mb-0'>Mobile</h6>
                                        <div><small className='text-secondary'>Android , iOS</small></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card mb-3">
                        <div class="card-body p-3">
                            <div className='row mb-1'>
                                <div className='col-12'>
                                    <h6 class="mb-2">Other Services</h6>
                                </div>
                            </div>
                            <div className='border border-light rounded ps-2 pe-2 pt-2 pb-2 mb-2'>
                                <Link to="https://chequeprint.co.in/" target='_blank' className='text-dark'>
                                    <div class="row align-items-center">
                                        <div class="col-auto">
                                            <div class="avatar-sm bg-white fs-lg ">
                                                <i className="bx bx-printer" style={{ "fontSize": "30px" }}></i>
                                            </div>
                                        </div>
                                        <div class="col ms-n3">
                                            <h6 className='mb-0'>Cheque Print</h6>
                                            <div><small className='text-secondary'>Software</small></div>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
                
            <AppInstallGuide />
        </>
    );
}

export default Dashboard;